import { Api } from 'services/api';

const BASE_URL = process.env.REACT_APP_ONEPAPER_API_DOMAIN;

export const getPaperPackage = async (params) => {
  const response = await Api.get(`${BASE_URL}/api/Nani/PaperPackage`, params);
  return response;
};
